import { Label } from '@headlessui/react';

import Props from '@/components/@base/input/radio/label/type';

export default function RadioLabel({ children, ...props }: Props) {
  return <Label {...props}>{children}</Label>;
}
